import React from 'react'
import { useDispatch } from 'react-redux'
import Button from 'src/components/Button'
import theme from 'src/styles/theme'
import { actions } from '../../FractionState'
import * as S from './ScaleWeight.styles'
import { Batch } from '../../FractionTypes'
import { useSelector } from 'src/utils/store'
import dayjs from 'dayjs'

interface ScaleWeightProps {
  nextField?: string
  batch: Batch
}

const ScaleWeight: React.FC<ScaleWeightProps> = ({ nextField, batch }) => {
  const dispatch = useDispatch()
  const { isRemotePrinterConnected, fractionTag } = useSelector((state) => state.fraction)

  const onSuccess = React.useCallback((weight: number | undefined) => {
    if (nextField) {
      if (isRemotePrinterConnected && fractionTag && batch.fractioning_tag && weight) {
        dispatch(actions.printFractionTag({
          productDescription: batch.descricao,
          productCode: `Código: ${batch.cod_produto}`,
          productBarcode: batch.cod_produto,
          batchId: `Id_lote: ${batch.id_lote}`,
          fractionInclusionDate: `Fracionado: ${dayjs(new Date()).format('DD/MM/YYYY')}`,
          weight: `Peso: ${weight} Kg`,
        }))
      }
      setTimeout(() => document.getElementById(nextField)?.focus(), 1)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextField])

  const getScaleWeight = React.useCallback(() => {
    dispatch(actions.getScaleWeight({ onSuccess }))
  }, [dispatch, onSuccess])

  const handleKeydown = React.useCallback((event: KeyboardEvent) => {
    if (event.code === 'Space') {
      event.preventDefault()
      dispatch(actions.getScaleWeight({ onSuccess }))
    }
  }, [dispatch, onSuccess])

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeydown)

    return () => {
      document.removeEventListener('keydown', handleKeydown)
      dispatch(actions.clearField('scaleWeight'))
    }
  }, [dispatch, getScaleWeight, handleKeydown])

  return (
    <S.ButtonContainer>
      <Button
        tabIndex={-1}
        type='button'
        testId='button-get-scale-weight'
        onClick={getScaleWeight}
        text='fraction.form.weight'
        color={theme.colors.green2}
        hoverColor={theme.colors.green2}
        style={{ display: 'none' }}
      />
    </S.ButtonContainer>
  )
}

export { ScaleWeight }
